// btw-front/src/lib/nav.js
// 앱 내 히스토리가 있으면 실제 이전 화면으로 돌아가고(navigate(-1)),
// 없으면(외부에서 상세 URL로 직접 진입 등) fallback 경로로 이동한다.
// react-router 는 history.state.idx 로 스택 위치를 관리 — 0 이면 앱 내 뒤로갈 곳이 없음.
export function goBackOr(navigate, fallback) {
  const idx = window.history.state && window.history.state.idx;
  if (typeof idx === "number" && idx > 0) navigate(-1);
  else navigate(fallback);
}
